import styles from "./PositionCardv2.module.css";
import Popover from "@material-ui/core/Popover";
import { useState } from "react";
import { Link } from "react-router-dom";
import { getRandomArbitrary } from "../../../utils/general";
import Button from "../../misc/Button/Button";


import { ImMenu3 } from "react-icons/im";
const PositionCardv2 = ({ posDetail, posHash }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  console.log(posHash)

  const {
    baseTokenSymbol,
    baseTokenImage,
    quoteTokenSymbol,
    quoteTokenImage,
    range,
    baseQty,
    quoteQty,
    lowerPrice,
    upperPrice,
    lpType,
  } = posDetail;

  const RepositionAndRemoveButtons = (
    <div className={styles.action_buttons_container}>
      <button className={styles.reposition_button}>Reposition</button>
      <button className={styles.remove_button}>Remove</button>
    </div>
  );
  const RemoveButton = (
    <button className={styles.remove_button_only}>Remove</button>
  );

  const inRangeCircle = (
    <div className={styles.in_range_display}>
      <span
        className={
          range ? styles.range_text_positive : styles.range_text_negative
        }
      >
        {range ? "In Range" : "Out of Range"}
      </span>
    </div>
  );

  const handlePopoverClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };



  const open = Boolean(anchorEl);
  const popoverId = open ? "simple-popover" : undefined;

  
  const TempAPY = getRandomArbitrary(0, 40).toFixed(2)

  const TempAPYstyle = TempAPY > 30 ? "primary_apy" : TempAPY > 10 && TempAPY < 30 ? "secondary_apy" : "apy"

  const popperContent = (
    <div className={styles.position_popperContent}>
    

      <button className={styles.action_button}>Harvest</button>
      <button className={styles.action_button}>Edit</button>
      <button className={styles.action_button}>Remove</button>
      {!range && (
         <Link to={`/position/reposition/${posHash}`} state={{posDetail: posDetail, TempAPY: TempAPY}}>
         <span className={styles.action_button}>Reposition</span>
         </Link>
      )}
      <Link to={`/position/details/${posHash}`} state={{posDetail: posDetail, TempAPY: TempAPY}}>
      <span className={styles.action_button}>Details</span>
      </Link>
    </div>
  );

 
  const myCardLeft = (
    <div className={styles.position_card}>
      <div className={styles.left_side}>
        <section>
          <div className={styles.position_images}>
            <img src={baseTokenImage} alt="" width="30px" />
            <img src={quoteTokenImage} alt="" width="30px" />
          </div>
          <div className={styles.tokens_names}>
            {baseTokenSymbol}/{quoteTokenSymbol}
          </div>
          <div className={styles.fee_tier}>0.05%</div>
        </section>
        <section className={styles.position_hash}>0xfa05...db35</section>
        <section className={styles.range_qty}>
          {lowerPrice?.toFixed(2)} - {upperPrice?.toFixed(2)}{" "}
          {!lowerPrice && !upperPrice && "Ambient"}
        </section>
        <section className={TempAPYstyle}>{ TempAPY}%</section>
      </div>
      <div className={styles.right_side}>
        {inRangeCircle}
       
          <button className={styles.details_button}>Details</button>
       
        <div
          aria-describedby={popoverId}
          onClick={handlePopoverClick}
          className={styles.more_icon}
        >
          <ImMenu3 size={22} />
        </div>
        <Popover
        popoverId={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
              {popperContent}
      </Popover>
      </div>
    </div>
  );

  return <div className={styles.position_card_v2}>{myCardLeft}</div>;
};

export default PositionCardv2;
